import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import { useHistory, useLocation } from "react-router-dom";
import { TextField, Grid, Chip, Divider } from "@material-ui/core";
import InputComponent from "../../../../../../Components/FormGenerator/input_component";
import CloseIcon from "@material-ui/icons/Close";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {
  SetTrainingAndDevelopment,
  SetTrainingAndDevelopmentError,
} from "./TrainingAndDevelopmentActions";
import { useParams } from "react-router-dom";
import SelectSpecific from "../../../../../../Components/FormGenerator/select_specific";
// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export const OnBoardingOptions = [
  { id: "Onboarding", label: "Onboarding", value: "Onboarding" },
  {
    id: "Acuity Profile created (still to complete other stages)",
    label: "Acuity Profile created (still to complete other stages)",
    value: "Acuity Profile created (still to complete other stages)",
  },
];
export const UtilisedOptions = [
  { id: "Screened In", label: "Screened In", value: "Screened In" },
  { id: "Shortlisted", label: "Shortlisted", value: "Shortlisted" },
  { id: "Placed", label: "Placed", value: "Placed" },
];
export const RankingOptions = [
  { id: "Bottom Quartile", label: "Bottom Quartile", value: "Bottom Quartile" },
  { id: "Lower Quartile", label: "Lower Quartile", value: "Lower Quartile" },
  { id: "Middle Quartile", label: "Middle Quartile", value: "Middle Quartile" },
  { id: "Top Quartile", label: "Top Quartile", value: "Top Quartile" },
];
export const DoNotContactOptions = [
  {
    id: "No Contact Details",
    label: "No Contact Details",
    value: "No Contact Details",
  },
  {
    id: "Application not progressed",
    label: "Application not progressed",
    value: "Application not progressed",
  },
  {
    id: "Not screened in yet",
    label: "Not screened in yet",
    value: "Not screened in yet",
  },
  { id: "Screened out", label: "Screened out", value: "Screened out" },
  { id: "Inactive", label: "Inactive", value: "Inactive" },
];
export const TagsOptions = [
  { id: "Future projects", label: "Future projects", value: "Future projects" },
];
// export interface GroupedOption {
//   readonly label: string;
//   readonly options:  readonly TagsOption[]| readonly DoNotContactOption[]| readonly RankingOption[]| readonly UtilisedOption[]| readonly OnBoardingOption[];
// }
const myData = [
  { text: "Atlanta", label: "US", value: "atl" },
  { text: "Boston", label: "US", value: "bos" },
  { text: "Bath", label: "UK", value: "bat" },
  { text: "Bristol", label: "UK", value: "bri" },
];
const groupedOptions = [
  {
    label: "Onboarding",
    options: [
      { id: "Onboarding", label: "Onboarding", value: "Onboarding" },
      {
        id: "Acuity Profile created (still to complete other stages)",
        label: "Acuity Profile created (still to complete other stages)",
        value: "Acuity Profile created (still to complete other stages)",
      },
    ],
  },
  {
    label: "Utilised",
    options: UtilisedOptions,
  },
  {
    label: "Ranking",
    options: RankingOptions,
  },
  {
    label: "Do not contact",
    options: DoNotContactOptions,
  },
  {
    label: "Tags",
    options: TagsOptions,
  },
];

export default function TrainingAndDevelopment(props) {
  const dispatch = useDispatch();
  // const location = useLocation();
    const globaluserData = useSelector((state) => state.commonReducer);
    const userRole = globaluserData?.role;
    const userRoleInternal = globaluserData?.jobRole
  
  const hideField = [
    // "Candidate status",
    "Internal notes",
    "Acuity admin field",
    "List of programmes available for delivery with request",
    "Internal status",
  ];
  const hideFieldInternal = ["Internal status"];
  const {
    courses_undertaken,
    cpd_hrs_undertaken_by_calendar_year,
    assignments_and_development_to_date,
    assignments_and_development_to_date_participated,
    assignments_and_development_to_date_delivered,
    future_assignment_options,
    qualified_as_a_coach,
    ambition,
    facilitation_skill_topics,
    facilitation_skills_topics,
    acuity_admin_field,
    employee_candidate_statuses,
    internal_notes,
    role_experience,
    last_job_title,
    levels_coach_at,
    thumbnail_bio,
    industry_sector_lists,
    disciplines,
    client_levels_available_for,
    worked_in_public_sector,
    worked_in_private_sector,
    client_levels_works_at_selected_options,
    cpd_num_of_hrs,
    client_level_works_at,

    list_of_programmes_available = "",
  } = useSelector((state) => state.trainingAndDevelopmentReducer.data);
  const reducerData = useSelector(
    (state) => state.trainingAndDevelopmentReducer.data
  );

  const {
    level_structure_values,
    assignment_and_development_to_date,
    future_assignment_options: futureAssignmentOptions,
    cpd_hrs_undertaken_by_calendar_year: cpdSelector,
  } = useSelector((state) => state.commonReducer.employeeDropdowns);
  const candidateStatuseSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.candidate_statuses
  );

  const futureAssignmentOptionSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.future_assignment_options
  );

  const facilitationSkillSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.facilitation_skill_topics
  );
  const IndustrySectorListSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.industry_sector_lists
  );

  const errors = useSelector(
    (state) => state.trainingAndDevelopmentReducer.errors
  );
  let { id } = useParams();

  const handleInputChange = (
    value,
    index,
    type,
    isDynamicField,
    selectValue,
    key
  ) => {
    props.setSomeChangeDetected(true);
    const updatedForm = formInput;
    let keyIndex = index;
    console.log(value, "value", index, type, isDynamicField, selectValue, key);
    if (value === "removeSelect") {
      const updatedForm = [...formInput];
      const formData = {};
      updatedForm.forEach((item) => {
        if (
          item.name === "facilitation_skill_topics" &&
          selectValue === "Yes"
        ) {
          formData[item.name] = item.value ?? "";
          dispatch(SetTrainingAndDevelopment(formData));
        } else if (
          item.name === "facilitation_skill_topics" &&
          selectValue === "No"
        ) {
          updatedForm[item.name] = [];
          setFormInput(updatedForm);
          formData[item.name] = [];
          dispatch(SetTrainingAndDevelopment(formData));
        }
      });
    } else {
      // else if (value === "removeSelect") {
      //   // const updatedForm = [...formInput];
      //   // const formData = {};
      //   // updatedForm.forEach((item) => {
      //   //   if (
      //   //     item.name === "facilitation_skill_topics" &&
      //   //     selectValue === "Yes"
      //   //   ) {
      //   //     formData[item.name] = item.value ?? "";
      //   //   }
      //   //   formData[item.name] = item.value ?? "";
      //   //   dispatch(SetTrainingAndDevelopment(formData));
      //   // });
      //   const updatedForm = [...formInput];
      //   console.log('first', value,updatedForm)
      //   const formData = {};
      //   updatedForm.forEach((item) => {
      //     if (
      //       item.name === "facilitation_skill_topics" ||
      //       selectValue === "Yes"
      //     ) {
      //       alert("hi")
      //       formData[item.name] = item.value ?? "";
      //       dispatch(SetTrainingAndDevelopment(formData));
      //     } else if (
      //       item.name === "facilitation_skill_topics" ||
      //      ( selectValue === "No" ||selectValue === "undefined")
      //     ) {
      //       alert("hiiiii")
      //       updatedForm[item.value] = [];
      //       setFormInput(updatedForm);
      //       formData[item.value] = [];
      //       dispatch(SetTrainingAndDevelopment(formData));
      //     }
      //   });
      // }
      //=====================================================
      // This logic is for updating the dynamic field's value
      const child = updatedForm[7]["fields"][index];
      if (isDynamicField) {
        child["value"] = value;
      } else if (key && !type) {
        keyIndex = formInput.findIndex((item) => item.name === key);
        updatedForm[keyIndex]["value"] = value;
      } else {
        updatedForm[index]["value"] = value;
      }

      setFormInput(updatedForm);
      const formData = {};

      formInput.forEach((item, fIndex) => {
        if (fIndex === index) {
          formData[item.name] = item.value ?? "";
          formData[item.inputName] = item.inputValue ?? "";
          formData[item.selectName] = item.selectValue ?? "";
          // dispatch(SetContactArea(formData));
        }
        // formData[item.name] = item.value ?? "";
      });
      if (key === "cpd_hrs_undertaken_by_calendar_year") {
        console.log(value, "updated formData");
        formData["cpd_hrs_undertaken_by_calendar_year"] = value;
      }

      // for dynamic genrated fields
      let modifiedData = [];
      formInput[7].value?.forEach((el) => {
        formInput[7]["fields"].forEach((item) => {
          if (item.for.includes(el?.toLowerCase())) {
            modifiedData.push({ level: el, notes: item.value });
          }
        });
      });

      formData["client_level_works_at"] = modifiedData;
      console.log(formData, "formData");
      dispatch(SetTrainingAndDevelopment(formData));
      dispatch(SetTrainingAndDevelopmentError(updatedForm[index]?.name));
    }
  };
  // Form disabling
  const location = useLocation();
 
  let organisation_id = globaluserData?.organisation_id;
  let employee_id = globaluserData?.employee_id;
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    userRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }
  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };
  const formArray = [
    {
      componentType: "input",
      type: "text",
      label: "Courses undertaken (CPD)",
      helperText:
        errors?.courses_undertaken && "Please enter courses undertaken (CPD)",
      name: "courses_undertaken",
      placeholder: "Courses undertaken (CPD)",
      handleChange: handleInputChange,
      value: courses_undertaken,
      multiline: true,
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "CPD number of hours",
    //   helperText:
    //     errors?.cpd_num_of_hrs && "Please enter CPD number of hours",
    //   name: "cpd_num_of_hrs",
    //   placeholder: "CPD number of hours",
    //   handleChange: handleInputChange,
    //   value: cpd_num_of_hrs,
    // },
    {
      componentType: "rederComponent",
      name: "cpd_hrs_undertaken_by_calendar_year",
      value: cpd_hrs_undertaken_by_calendar_year,
      component: (
        <CPDCalendarYear
          handleChange={handleInputChange}
          name="cpd_hrs_undertaken_by_calendar_year"
          value={cpd_hrs_undertaken_by_calendar_year}
          componentObject={[
            {
              label: "Year",
              placeholder: "Select year",
              componentType: "SelectSpecific",
              inputName: "cpd_hrs_undertaken_by_calendar_year",
              selectName: "currency_id",
              isDynamicField: "year",
              selectPlaceholder: "Select year",
              selectOptions: cpdSelector,
              handleChange: handleInputChange,
              isChild: true,
              disabled: unEditable,
            },
          ]}
        />
      ),
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "CPD Hours Undertaken by Calendar Year",
    //   helperText:
    //     errors.cpd_hrs_undertaken_by_calendar_year &&
    //     "Please enter CPD Hours Undertaken by Calendar Year",
    //   name: "cpd_hrs_undertaken_by_calendar_year",
    //   placeholder: "CPD Hours Undertaken by Calendar Year",
    //   handleChange: handleInputChange,
    //   value: cpd_hrs_undertaken_by_calendar_year,
    // },

    {
      componentType: "input",
      label: "Assignments and development to date",
      multiline: true,
      infoIcon: "yes",
      infoMessage:
        "Please broadly describe what development you have received to date and the year if available",
      helperText:
        errors &&
        errors.assignments_and_development_to_date_participated &&
        "Please Yes or No",
      name: "assignments_and_development_to_date_participated",
      value: assignments_and_development_to_date_participated,
      placeholder: "Assignments and development to date",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      label: "Assignments and development to date delivered",
      multiline: true,
      infoIcon: "yes",
      infoMessage:
        "Please describe broadly what internal engagements you have delivered. Going forward when the system is used it will capture your future delivery. When Clients are looking at your profile it will be useful to see what has been delivered.",
      helperText:
        errors &&
        errors.assignments_and_development_to_date_delivered &&
        "Please Yes or No",
      name: "assignments_and_development_to_date_delivered",
      value: assignments_and_development_to_date_delivered,
      placeholder: "Assignment and development to date delivered",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },

    //this feild is avaliable once client give some clarification on this
    {
      componentType: "multiSelectChip",
      // type: "text",
      label: "Future assignment options",
      helperText:
        errors?.future_assignment_options &&
        "Please enter Future Assignment Options",
      name: "future_assignment_options",
      placeholder: "Future assignment options",
      handleChange: handleInputChange,
      value: future_assignment_options,
      itemArr: futureAssignmentOptionSelector,
      selectOptions: futureAssignmentOptionSelector,
      dropDown: "FutureAssignment",
      field_name: "name",
    },
    {
      componentType: "input",
      type: "text",
      label: "Ambition",
      multiline: true,
      helperText:
        errors?.ambition &&
        "Please describe what stretches you and the direction you want to go in",
      name: "ambition",
      placeholder:
        "Please describe what stretches you and the direction you want to go in",
      handleChange: handleInputChange,
      value: ambition,
    },
    // {
    //   componentType: "select",
    //   label: "Future assignment options",
    //   helperText: errors && errors.future_assignment_options && "Select Future assignment options",
    //   name: "future_assignment_options",
    //   value: future_assignment_options,
    //   placeholder: "Select Future assignment options",
    //   selectOptions: futureAssignmentOptions,
    //   handleChange: handleInputChange,
    // },
    {
      componentType: "select",
      label: "Qualified as a coach",
      helperText: errors && errors.qualified_as_a_coach && "Please yes or no",
      name: "qualified_as_a_coach",
      value: qualified_as_a_coach,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },

    {
      componentType: "DynamicFields",
      name: "client_levels_works_at_selected_options",
      // value: client_levels_works_at_selected_options,
      value: client_level_works_at?.map((item) => item?.level),
      placeholder: "Levels permitted to coach",
      // selectOptions: client_levels_available,
      fields: [],
      selectOptions: level_structure_values,
      // apiVariable: "level_dropdown_values",
      // params: {organisation_id: id},
      handleChange: handleInputChange,
      // label:`What Client (${location?.state?.orgName}) levels are you available for `,
      label: `Levels permitted to coach`,
      helperText:
        errors?.client_levels_works_at_selected_options &&
        "Please enter Levels permitted to coach",
    },
    // {
    //   componentType: "select",
    //   name: "client_levels_available_for",
    //   value: client_levels_available_for,
    //   placeholder: "Client Specific what levels they would work at with notes in a text box next to Level/Grade",
    //   selectOptions: client_levels_available,
    //   // apiVariable: "level_dropdown_values",
    //   // params: {organisation_id: id},
    //   handleChange: handleInputChange,
    //   label: `Client levels available for`,
    //   helperText:
    //     errors.client_level_works_at &&
    //     "Please enter Client Specific what levels they would work at with notes in a text box next to Level/Grade",
    // },
    {
      componentType: "selectWithMultiSelect",
      label: "Please select the facilitation specialisms",
      helperText:
        errors && errors.facilitation_skill_topics && "Please yes or no",
      name: "facilitation_skill_topics",
      value: facilitation_skill_topics,
      placeholder: "Please select the facilitation specialisms",
      selectValue: "No",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
      itemArr: facilitationSkillSelector,
      placeholder1: "Facilitation skill topics",

      // componentType1: "multiSelectChip",
      // // type: "text",
      // label1: "Facilitation Skill Topics",
      // helperText1:
      //   errors?.facilitation_skill_topics &&
      //   "Please enter Future Assignment Options",
      // name1: "facilitation_skill_topics",
      // placeholder1: "Future assignment options",
      // // handleChange: handleInputChange,
      // value1: facilitation_skill_topics,
      // itemArr1: facilitationSkillSelector,
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Client Facilitation Skills Topics",
    //   helperText:
    //     errors.facilitation_skills_topics &&
    //     "Please enter Facilitation Skills Topics",
    //   name: "facilitation_skills_topics",
    //   placeholder: "Please select the facilitation topics you can deliver against",
    //   handleChange: handleInputChange,
    //   value: facilitation_skills_topics,
    //   hoverText: "Please select the facilitation topics you can deliver against"
    // },
    {
      componentType: "input",
      type: "text",
      label: "Acuity admin field",
      multiline: true,
      helperText:
        errors?.acuity_admin_field && "Please enter Acuity Admin Field",
      name: "acuity_admin_field",
      placeholder: "Acuity admin field",
      handleChange: handleInputChange,
      value: acuity_admin_field,
    },

    {
      componentType: "input",
      label: "List of programmes available for delivery with request",
      name: "list_of_programmes_available",
      value: list_of_programmes_available?.length
        ? list_of_programmes_available.join("\n")
        : "",
      multiline: true,
      disabled: true,
      // id: "services_offered",
      // placeholder: "Services offered",
      // itemArr: services_offereds,

      handleChange: handleInputChange,
    },
    // {
    //   componentType: "rederComponent",
    //   component: <CustomListPromgrammer
    //     label="List of programmes available for delivery with request"
    //     programmerList={list_of_programmes_available}
    //   />
    // },
    {
      componentType: "select",
      label: "Worked in public sector",
      helperText:
        errors &&
        errors.worked_in_public_sector &&
        "Please enter Worked in public sector",
      name: "worked_in_public_sector",
      value: worked_in_public_sector,
      placeholder: "Worked in public sector",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      label: "Worked in private sector",
      helperText:
        errors &&
        errors.worked_in_private_sector &&
        "Please enter Worked in private sector",
      name: "worked_in_private_sector",
      value: worked_in_private_sector,
      placeholder: "Worked in private sector",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: "Internal status",
      name: "employee_candidate_statuses",
      placeholder: "Select internal status",
      itemArr: candidateStatuseSelector,
      id: "employee_candidate_statuses",

      // selectOptions: employee_candidate_statuses,
      // helperText: errors && errors.employee_candidate_statuses && "Please Select Candidate Status",
      value: employee_candidate_statuses,

      handleChange: handleInputChange,
      dropDown: "EmployeeCandidateStatus",
      field_name: "candidate_status_name",
    },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Internal notes",
      helperText: errors?.internal_notes && "Please enter Internal notes",
      name: "internal_notes",
      placeholder: "Internal notes",
      handleChange: handleInputChange,
      value: internal_notes,
    },

    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Role Experience",
    //   helperText: errors.role_experience && "Please enter Role Experience",
    //   name: "role_experience",
    //   placeholder: "Role Experience",
    //   handleChange: handleInputChange,
    //   value: role_experience,
    // },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Last Job Title",
    //   helperText: errors.last_job_title && "Please enter Last Job Title",
    //   name: "last_job_title",
    //   placeholder: "Last Job Title",
    //   handleChange: handleInputChange,
    //   value: last_job_title,
    // },

    // {
    //   componentType: "select",
    //   // apiVariable: "level_dropdown_values",
    //   selectOptions: level_structure_values,
    //   params: { organisation_id: id },
    //   label: "Levels Coach at",
    //   helperText: errors.levels_coach_at && "Please enter Levels Coach at",
    //   name: "levels_coach_at",
    //   placeholder: "Levels Coach at",
    //   handleChange: handleInputChange,
    //   value: levels_coach_at,
    // },
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Thumbnail Bio",
    //   helperText: errors.thumbnail_bio && "Please enter Thumbnail Bio",
    //   name: "thumbnail_bio",
    //   placeholder: "Thumbnail Bio",
    //   handleChange: handleInputChange,
    //   value: thumbnail_bio,
    // },
    // {
    //   componentType: "MultipleSelect",
    //   label: "Industry Sector",
    //   name: "industry_sector_lists",
    //   value: industry_sector_lists,
    //   placeholder: "Select Industry Sector",
    //   selectOptions: IndustrySectorListSelector,
    //   // apiVariable: "industry_sectors",
    //   handleChange: handleInputChange,
    //   helperText:
    //     errors &&
    //     errors.industry_sector_lists &&
    //     "Please select a Industry Sector",
    //   dropDown: "IndustrySectorList",
    //   field_name: "industry_sector",
    // },
    // {
    //   componentType: "MultipleSelect",
    //   label: "Disciplines",
    //   helperText: errors && errors.disciplines && "Please select Disciplines",
    //   name: "disciplines",
    //   value: disciplines,
    //   placeholder: "Select Disciplines",
    //   selectOptions: disciplinesSelector,
    //   // selectOptions: [
    //   //   { id: 0, value: "Business Development", name: "Business Development" },
    //   //   { id: 1, value: "Change Management", name: "Change Management" },
    //   //   { id: 1, value: "Consulting", name: "Consulting" },
    //   //   { id: 1, value: "Finance", name: "Finance" },
    //   //   { id: 1, value: "HR/People", name: "HR/People" },
    //   //   { id: 1, value: "IT", name: "IT" },
    //   //   { id: 1, value: "Marketing", name: "Marketing" },
    //   //   { id: 1, value: "Networking & Communications", name: "Networking & Communications" },
    //   //   { id: 1, value: "Operations", name: "Operations" },
    //   //   { id: 1, value: "P&L Management", name: "P&L Management" },
    //   //   { id: 1, value: "Project or Programme Management", name: "Project or Programme Management" },
    //   //   { id: 1, value: "Research & Development", name: "Research & Development" },
    //   //   { id: 1, value: "Risk & Compliance", name: "Risk & Compliance" },
    //   //   { id: 1, value: "Sales", name: "Sales" },
    //   // ],
    //   handleChange: handleInputChange,
    //   dropDown: "Discipline",
    //   field_name: "discipline",
    // },

    // {
    //   componentType: "checkedDropdown",
    //   label: "Candidate Status",
    //   value: employee_candidate_statuses,
    //   name: "employee_candidate_statuses",
    //   placeholder: "Candidate Status",
    //   selectOptions: groups,
    //   handleChange: handleValChange,
    // },

    // {
    //   componentType: "GroupDropdown",
    //   label: "Candidate Status",
    //   helperText:
    //     errors.employee_candidate_statuses && "Please enter Candidate Status",
    //   name: "employee_candidate_statuses",
    //   placeholder: "Candidate Status",
    //   id: "employee_candidate_statuses",
    //   // selectOptions: languages_list,
    //   reducerData: reducerData,

    //   value: [],
    //   itemArr: groupedOptions,

    //   section:"trainingAndDev",
    //   selectOptions: employee_candidate_statuses,
    // },
  ];

  const RoleWiseField = formArray.filter((item) =>
    userRole === "employee"
      ? !hideField.includes(item.label)
      : userRoleInternal && userRoleInternal.includes("Internal") === false
      ? !hideFieldInternal.includes(item.label)
      : item
  );

  const [formInput, setFormInput] = useState(RoleWiseField);
  // useEffect(() => {
  //   // setFormInput(formArray);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [errors, cpdSelector,futureAssignmentOptionSelector]);

  useEffect(() => {
    setFormInput((prevState) => {
      const updatedState = [...prevState];

      const newlyAddedFields = [];

      const selectedOptions =
        client_levels_works_at_selected_options ||
        client_level_works_at?.map((item) => item?.level);

      selectedOptions?.forEach((item, i) => {
        const { notes } = client_level_works_at[i] || {};
        const name = `${item.split(" ").join("_")}_notes`;
        newlyAddedFields.push({
          fieldType: "input",
          type: "text",
          multiline: true,
          label: `Notes for level ${item}`,
          value: notes,
          helperText: errors?.internal_notes && `Please enter ${item} notes`,
          name: name,
          placeholder: `${item} notes`,
          for: item?.toLowerCase(),
          handleChange: handleInputChange,
        });
      });

      updatedState[7]["fields"] = [...newlyAddedFields];
      updatedState[4]["itemArr"] = [...futureAssignmentOptionSelector];
      if (userRole !== "employee") {
        updatedState[13]["itemArr"] = [...candidateStatuseSelector];
      }
      const updatedStateWithError = updatedState.map((item) => ({
        ...item,
        ...(errors &&
          errors[item.name] && {
            helperText: errors[item.name]
              ? `Please select ${item.label.replace("*", "")}`
              : null,
          }),
      }));

      return updatedStateWithError;
    });
  }, [
    errors,
    client_levels_works_at_selected_options,
    client_level_works_at,
    cpdSelector,
    candidateStatuseSelector,
    futureAssignmentOptionSelector,
  ]);

  console.log("formInput", formInput);
  return (
    <FormGenerator
      children={formInput.map(formDisabler)}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red",
  },
  disabled: {
    background: "#f5f2f2",
  },

  textInput: {
    "& input::placeholder": {
      color: "#808080",
      opacity: 1,
    },
  },
  addCircleIcon: {
    color: "#EF7000",
  },
}));

const CustomListPromgrammer = (props) => {
  const { programmerList, label } = props;
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12} md={4}>
        {label}
      </Grid>
      <Grid xs={12} md={7}>
        <Grid style={{ marginBottom: 20, opacity: 0.8 }}>
          <TextField
            variant="outlined"
            multiline
            disabled
            rows={4}
            defaultValue={programmerList?.length ? "" : label}
            InputProps={{
              startAdornment: programmerList?.map((item) => (
                <Chip key={item.id} label={item.value} variant="outlined" />
              )),
              classes: {
                disabled: classes.disabled,
              },
              style: { alignItems: "start" },
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
// CPDCalendarYear
const CPDCalendarYear = (props) => {
  const classes = useStyles();
  const { name, handleChange } = props;
  const [calendarYear, setCalendarYear] = useState([]);

  const { cpd_hrs_undertaken_by_calendar_year } = useSelector(
    (state) => state.trainingAndDevelopmentReducer.data
  );

  const handleInputChange = useCallback(
    (value, index, type, dynamicField) => {
      setCalendarYear((prevState) => {
        prevState[index] = { ...prevState[index] };
        prevState[index][dynamicField] = value;
        return [...prevState];
      });
      calendarYear?.length && handleChange(calendarYear, 0, "", "", "", name);
    },
    [calendarYear]
  );

  useEffect(() => {
    if (cpd_hrs_undertaken_by_calendar_year?.length)
      setCalendarYear(cpd_hrs_undertaken_by_calendar_year);
    else
      setCalendarYear([
        {
          year: "",
          hour: "",
        },
      ]);
  }, [cpd_hrs_undertaken_by_calendar_year]);

  const handleIncome = (isAdd, index) => {
    if (isAdd) {
      const newCall = {
        hour: "",
        year: "",
      };
      const newItem = [...calendarYear, ...[newCall]];
      setCalendarYear(newItem);
      handleChange(newItem, 0, "", "", "", name);
    } else {
      calendarYear.splice(index, 1);
      handleChange(calendarYear, 0, "", "", "", name);
      setCalendarYear([...calendarYear]);
    }
  };

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4}>
        CPD hours undertaken by calendar year
      </Grid>
      <Grid item xs={12} md={7}>
        {calendarYear?.map((item, index) => {
          const formInputFields = {
            ...props?.componentObject[0],
          };
          formInputFields.handleChange = handleInputChange;
          formInputFields.value = item.year;
          formInputFields.index = index;
          return (
            <>
              <Grid container spacing={1}>
                <Grid item xs={1} style={{ alignItems: "center" }}>
                  Year
                </Grid>
                <Grid item xs={5} style={{ marginTop: "-11px" }}>
                  <SelectSpecific
                    key={index}
                    componentObject={formInputFields}
                  />
                </Grid>
                <Grid item xs={1}>
                  Hours
                </Grid>
                <Grid item xs={4} style={{ marginTop: "-11px" }}>
                  <InputComponent
                    key={index}
                    componentObject={{
                      type: "number",
                      name: "hour",
                      isDynamicField: "hour",
                      placeholder: "Select hours",
                      handleChange: handleInputChange,
                      value: item.hour,
                      index: index,
                      hideLabel: true,
                      disabled: props?.componentObject[0]?.disabled,
                    }}
                  />
                </Grid>

                {!props?.componentObject[0]?.disabled && (
                  <Grid item xs={1}>
                    {
                      !index ? (
                        <AddCircleIcon
                          type="submit"
                          onClick={() => handleIncome(true, 0)}
                          fontSize="large"
                          color="primary"
                          style={{ cursor: "pointer", marginTop: "-11px" }}
                        />
                      ) : (
                        <AddCircleIcon
                          type="submit"
                          onClick={() => handleIncome(false, index)}
                          fontSize="large"
                          color="error"
                          style={{
                            cursor: "pointer",
                            marginTop: "-11px",
                            transform: "rotate(45deg)",
                          }}
                        />
                      )

                      // <CloseIcon type={'submit'}
                      //   fontSize="medium"
                      //   style={{
                      //     cursor: 'pointer',
                      //     transform: 'rotate(45deg)'
                      //   }}
                      //   onClick={() => handleIncome(false, index)} />
                    }
                  </Grid>
                )}
              </Grid>
              {index === calendarYear?.length - 1 && (
                <Divider style={{ marginBottom: "20px" }} />
              )}
            </>
          );
        })}
      </Grid>
    </Grid>
  );
};
